import {
  CloseButton as MantineCloseButton,
  CloseButtonProps as MantineCloseButtonProps,
} from '@mantine/core';
import { ComponentPropsWithoutRef, forwardRef } from 'react';

import styles from './CloseButton.module.css';

type BaseCloseButtonProps = Omit<
  MantineCloseButtonProps,
  'variant' | 'color' | 'styles' | 'classNames' | 'style'
>;

export type CloseButtonProps = BaseCloseButtonProps &
  Omit<
    ComponentPropsWithoutRef<'button'>,
    keyof BaseCloseButtonProps | 'style'
  >;

export const CloseButton = forwardRef<HTMLButtonElement, CloseButtonProps>(
  ({ className, ...props }, ref) => {
    const rootClassName = [styles.root, className].filter(Boolean).join(' ');

    return (
      <MantineCloseButton
        ref={ref}
        unstyled
        classNames={{ root: rootClassName }}
        iconSize={20}
        {...props}
      />
    );
  }
);

CloseButton.displayName = 'CloseButton';
